import { useMutation, useQuery } from "@tanstack/react-query";

import {
  Button,
  Drawer,
  Form,
  Image,
  Input,
  InputNumber,
  Modal,
  Popconfirm,
  Table,
  Typography,
  message,
} from "antd";

import { useState } from "react";
import AddTo from "../components/Add/category/AddTo";
import useSearch from "../components/Search";
import {
  addCategory,
  deleteCategory,
  getAllAlbum,
  getAllCategories,
  getMusic,
  updateCategory,
} from "../utils/api";
import { useAuth } from "../utils/store";

const Categories = () => {
  const user = useAuth((state) => state.user);
  const [messageApi, contextHolder] = message.useMessage();
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["categories"],
    queryFn: async () => await getAllCategories(),
  });
  const { data: musics } = useQuery({
    queryKey: ["musics"],
    queryFn: async () => await getMusic(),
  });
  const { data: albums } = useQuery({
    queryKey: ["albums"],
    queryFn: async () => await getAllAlbum(),
  });

  const search = useSearch();

  const { mutate, isLoading: isLoading2 } = useMutation(
    async (values) => await deleteCategory(values),
    {
      onSuccess: () => {
        messageApi.success(`Deleted`);
        refetch();
      },
    }
  );

  console.log(data);

  const columns = [
    {
      title: "S.no",
      dataIndex: "sno",

      render(value, record, index) {
        return index + 1;
      },
    },
    {
      title: "Actions",
      dataIndex: "action",
      render(value, record) {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 10,
            }}
          >
            <AddTo
              row={record}
              refetch={refetch}
              musics={musics}
              albums={albums}
            />
            <AddData update={record} refech={refetch} />

            <Popconfirm
              title="Delete the task"
              description="Are you sure to delete this task?"
              okText="Yes"
              cancelText="No"
              onConfirm={() => mutate(record._id)}
            >
              <Button
                style={{
                  width: "200px",
                }}
                danger
                loading={isLoading2}
              >
                Delete
              </Button>
            </Popconfirm>
          </div>
        );
      },
    },

    {
      title: "Name",
      dataIndex: "name",
      ...search("name"),
    },
    {
      title: "Content",
      dataIndex: "content",
      render(value) {
        return <Content data={value} />;
      },
    },
  ];
  return (
    <div
      style={{
        padding: 24,
      }}
    >
      {contextHolder}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 20,
        }}
      >
        <Typography style={{ fontSize: 20, fontWeight: 600, marginBottom: 10 }}>
          Categories
        </Typography>
        <AddData refech={refetch} />
      </div>
      <Table columns={columns} dataSource={data} loading={isLoading} />
    </div>
  );
};

export default Categories;

const Content = ({ data }) => {
  const [visible, setVisible] = useState(false);
  return (
    <>
      <Button
        type="primary"
        style={{ marginRight: 10 }}
        onClick={() => setVisible(true)}
      >
        View
      </Button>

      <Drawer
        width={800}
        open={visible}
        onClose={() => setVisible(false)}
        title="Content"
      >
        <Table
          columns={[
            {
              title: "Type",
              dataIndex: "kind",
            },
            {
              title: "Name",
              dataIndex: ["item", "name"],
            },
            {
              title: "cover",
              dataIndex: ["item", "cover"],
              render: (value) => <Image src={value} width={100} height={100} />,
            },
          ]}
          dataSource={data}
        />
      </Drawer>
    </>
  );
};

const AddData = ({
  refech,

  update,
}) => {
  const [messageApi, contextHolder] = message.useMessage();
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();

  const { mutate, isLoading } = useMutation(
    async (values) =>
      update
        ? await updateCategory(update._id, values)
        : await addCategory(values),
    {
      onSuccess: () => {
        messageApi.success(`Added`);
        //reset form
        !update && form.resetFields();
        refech();
        setVisible(false);
      },
      onError: (err) => {
        messageApi.error(err?.response?.data?.message);
      },
    }
  );

  return (
    <div>
      {contextHolder}
      <Button
        style={{
          width: "200px",
        }}
        type="primary"
        onClick={() => setVisible(true)}
      >
        {update ? "Update" : "Add"}
      </Button>
      <Modal
        title={update ? "Update " : "Add  "}
        open={visible}
        onCancel={() => setVisible(false)}
        footer={null}
      >
        <Form
          form={form}
          labelCol={{ span: 6 }}
          layout="horizontal"
          style={{
            maxWidth: 600,
            padding: 20,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
          initialValues={
            update && {
              name: update.name,
              position: update.position,
            }
          }
          onFinish={(values) => {
            console.log(values);

            mutate(values);
          }}
        >
          {" "}
          <Form.Item
            label="Name"
            name="name"
            required
            rules={[
              {
                required: true,
                message: "Please input your name",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Position"
            name="position"
            required
            rules={[
              {
                required: true,
                message: "Please input your position",
              },
            ]}
          >
            <InputNumber />
          </Form.Item>
          <Button type="primary" htmlType="submit" loading={isLoading}>
            Submit
          </Button>
        </Form>
      </Modal>
    </div>
  );
};
